
// If follow mouse objects are present in the page
if(jQuery('[fmouse-container]').length) {

    // Init vars
    var followmouse_elements = jQuery('[fmouse-container]');
    var elements = [];

    // FUNCTION : Register informations about elements following mouse
    function getFollowingElements() {
        var i = 0;
        jQuery.each(followmouse_elements, function() {
            var element = jQuery(this);
            var xQuicksetter = gsap.quickSetter(element[0], "x", "px");
            var yQuicksetter = gsap.quickSetter(element[0], "y", "px");
            var container = element.attr('fmouse-container');
            var offset_top = Math.round(jQuery(container).offset().top);
            var offset_left = Math.round(jQuery(container).offset().left);
            var end_top = Math.round(offset_top + jQuery(container).outerHeight());
            var end_left = Math.round(offset_left + jQuery(container).outerWidth());
            var speed = parseFloat(element.attr('fmouse-speed'));
            var outers = parseFloat(element.attr('fmouse-outers'));
            elements[i] = {
                object: element,
                xQuicksetter: xQuicksetter,
                yQuicksetter: yQuicksetter,
                offset_top: offset_top,
                offset_left: offset_left,
                end_top: end_top,
                end_left: end_left,
                speed: speed,
                outers: outers,
                in_range: false,
                passed: false
            };
            i++;
        });
    }
    
    // Run function on first load
    jQuery(document).ready(function () {
        getFollowingElements();
    });
    
    // On resize, compute new offsets and centers
    document.addEventListener('windowresize', (e) => {
        getFollowingElements();
    }, false);

    // Set followmouse elements transform to be centered on cursor
    gsap.set('[fmouse-container]', {xPercent: -50, yPercent: -50});
    
    // On GSAP tick, manage followmouse elements
    //var pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    var pos = { x: window.innerWidth / 5, y: window.innerHeight / 2 };
    const follow_speed = 0.2;
    gsap.ticker.add(() => {
  
        // adjust speed for higher refresh monitors
        const dt = 1.0 - Math.pow(1.0 - follow_speed, gsap.ticker.deltaRatio()); 
        
        // Compute new x y positions, adjusted by dt
        pos.x += (xPos - pos.x) * dt;
        pos.y += (yPos - pos.y) * dt;
        
        // Update each followmouse element Quicksetter
        if(typeof elements !== 'undefined' && elements.length > 0) {
            jQuery.each(elements, function() {
                element = jQuery(this);

                // If in range, follow mouse
                if(element[0].in_range) {
                    element[0].xQuicksetter(pos.x);
                    element[0].yQuicksetter(pos.y);
                
                // If not in range, block on top or bottom depending if passed or not
                } else {
                    if(element[0].passed) {
                        element[0].yQuicksetter(element[0].end_top + element[0].outers);
                    } else {
                        element[0].yQuicksetter(element[0].offset_top - element[0].outers);
                    }
                }
            });
        }
    });


    // On limited rate cursormove, check if elements are allowed to move
    document.addEventListener('cursormove', (e) => {
        if(typeof elements !== 'undefined' && elements.length > 0) {
            jQuery.each(elements, function() {
                var element = jQuery(this);
                var min_vert = element[0].offset_top - element[0].outers;
                var max_vert = element[0].end_top + element[0].outers;
                var half_vert = (min_vert + max_vert) / 2;
                var min_hori = element[0].offset_left - element[0].outers;
                var max_hori = element[0].end_left + element[0].outers;
                if(yPos > min_vert && yPos < max_vert && xPos > min_hori && xPos < max_hori) {
                    if(!element[0].in_range) { 
                        element[0].object.css('left', '0px');
                        element[0].object.css('top', '0px');
                        element[0].in_range = true;
                    }
                    // Remplacer l'animation gsap par le suivi de souris après apparition premier rond suivi
                    if(element[0].object.hasClass('gsap_animated')) {
                        element[0].object.css('left', '0px');
                        element[0].object.css('top', '0px');
                    }
                } else {
                    if(element[0].in_range) { element[0].in_range = false; }
                }

                if(yPos < half_vert) {
                    if(element[0].passed) { element[0].passed = false; }
                }
                if(yPos > half_vert) {
                    if(!element[0].passed) { element[0].passed = true; }
                }

                //i++;
            });
        }
        
    }, false);

    // // On mouse position change, move objects
    // document.addEventListener('cursormove', (e) => {
    //     moveObjects();
    // }, false);

    // // Move object to mouse position if in range
    // function moveObjects() {
    //     if(typeof followmouse_elements !== 'undefined' && followmouse_elements.length > 0) {
    //         var i = 0;
    //         jQuery.each(followmouse_elements, function() {
    //             if(typeof elements !== 'undefined' && elements.length > 0) {
    //                 var element = jQuery(this);
    //                 var min_vert = elements[i].offset_top - elements[i].outers;
    //                 var max_vert = elements[i].end_top + elements[i].outers;
    //                 var min_hori = elements[i].offset_left - elements[i].outers;
    //                 var max_hori = elements[i].end_left + elements[i].outers;
    //                 if(yPos > min_vert && yPos < max_vert && xPos > min_hori && xPos < max_hori) {
    //                     gsap.to(element, elements[i].speed, {
    //                         css: {
    //                             left: xPos - elements[i].offset_left,
    //                             top: yPos - elements[i].offset_top
    //                         },
    //                         overwrite: "auto"
    //                     });
    //                     // element.css('left', xPos - elements[i].offset_left);
    //                     // element.css('top', yPos - elements[i].offset_top);
    //                 }

    //                 i++;
    //             }
    //         });
    //     }
    // }
}



